import { ActionContext, ActionTree, MutationTree } from "vuex";
import { IMinuteurState, IRacineState } from "../models";

export const stateDeBase = (): IMinuteurState => {
  return {
    verrouDateFin: null,
    tempsRestantEnSeconde: null,
    tempsAlloueEchu: false,
    identifiantMinuteur: null,
  };
};

export const state: IMinuteurState = stateDeBase();

interface demarrageMinuteur {
  identifiantMinuteur: number;
  delaiVerrou: number;
}

interface IMutations {
  demarrerMinuteurSucces: (
    state: IMinuteurState,
    corps: demarrageMinuteur
  ) => void;
  arreterMinuteurSucces: (state: IMinuteurState) => void;
  diminuerTempsRestant: (state: IMinuteurState, secondes: number) => void;
  tempsAlloueEchu: (state: IMinuteurState, tempsAlloueEchu: boolean) => void;
  effacerStateMinuteur: (state: IMinuteurState) => void;
}

export const mutations: IMutations & MutationTree<IMinuteurState> = {
  demarrerMinuteurSucces: (state: IMinuteurState, corps: demarrageMinuteur) => {
    state.identifiantMinuteur = corps.identifiantMinuteur;
    state.verrouDateFin = Date.now() + corps.delaiVerrou * 60 * 1000; // X minutes
  },
  arreterMinuteurSucces: (state: IMinuteurState) => {
    if (state.identifiantMinuteur !== null) {
      clearInterval(state.identifiantMinuteur);
    }

    state.identifiantMinuteur = null;
    state.verrouDateFin = null;
    state.tempsRestantEnSeconde = null;
  },
  diminuerTempsRestant: (
    state: IMinuteurState,
    tempsRestantEnSeconde: number
  ) => {
    state.tempsRestantEnSeconde = tempsRestantEnSeconde;
  },
  tempsAlloueEchu: (state: IMinuteurState, tempsAlloueEchu: boolean) => {
    state.tempsAlloueEchu = tempsAlloueEchu;
  },
  effacerStateMinuteur: (state: IMinuteurState) => {
    Object.assign(state, stateDeBase());
  },
};

interface IActions {
  demarrerMinuteur: (
    context: ActionContext<IMinuteurState, IRacineState>,
    options: {
      delaiVerrou: number;
    }
  ) => void;
}

export const actions: IActions & ActionTree<IMinuteurState, IRacineState> = {
  demarrerMinuteur(context, { delaiVerrou }) {
    const identifiantMinuteur = window.setInterval(() => {
      if (context.state.verrouDateFin !== null) {
        const tempsRestant = Math.ceil(
          (context.state.verrouDateFin - Date.now()) / 1000
        );

        if (tempsRestant <= 0) {
          context.commit(mutations.tempsAlloueEchu.name, true);
          context.commit(mutations.arreterMinuteurSucces.name);
        } else {
          context.commit(mutations.diminuerTempsRestant.name, tempsRestant);
        }
      }
    }, 1000);

    if (context.state.verrouDateFin === null) {
      context.commit(mutations.demarrerMinuteurSucces.name, {
        identifiantMinuteur: identifiantMinuteur,
        delaiVerrou: delaiVerrou,
      });
    }
  },
};

export default {
  state,
  actions,
  mutations,
};
